const state = {
  adModalStatus: null
}

const getters = {
}

const mutations = {
  setAdModalStatus (state, adModalStatus) {
    localStorage.setItem('adModalStatus', JSON.stringify(adModalStatus))
    state.adModalStatus = adModalStatus
  }
}

const actions = {
}

export default { namespaced: true, state, getters, mutations, actions }
